import app from '../../app';
import template from './options.html';

app.component('options', { 
    template: template
});